import { CUSTOMER_SERVICE, JobType, NON_CUSTOMER_SERVICE } from "../../../config/appConfigConstants";
import { IN_CAAS_STATUS } from "../i9-data";

export const getINInstructionMapping = () => {
  const inDefaultInstructionMapping: {
    [key in JobType]: { [key in string]: JSX.Element | null };
  } = {
    [NON_CUSTOMER_SERVICE]: {},
    [CUSTOMER_SERVICE]: {},
  };

  return inDefaultInstructionMapping;
};
